// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_U-IKL","title":"index_title_o5-Gz","titleText":"index_titleText_5OA-w"};